<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-default shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3  text-white">Pricing
                                    <span>Competitive pricings.</span>
                                </h1>
                                
                                <p class="lead  text-white">Affordable quality custom software solutions catered for your business. 
                                            <br>Fast responses. Quality services.  Customer satisfaction.
                                </p>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        
        <section class="section section-lg">
              <div class="container container-lg">
            <div class="row">
                <div class="col-md-4 mb-4 mb-md-0">

                    <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-check-bold" type="primary" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-primary text-uppercase">Digital Transformation</h6>

                                    <p class="description mt-3">Outsource your software project</p>
                                
                                   <table class='table'>
                            
                                        <tr>
                                            <td colspan='2'>UI design</td>
                                        </tr>
                                        <tr>
                                        <td colspan='2'>Web & mobile development</td>
                                        </tr>
                                        <tr>
                                        <td colspan='2'>Product management</td>
                                        </tr>
                                        <tr>
                                        <td colspan='2'>Quality assurance</td>
                                        </tr>
                                        <tr>
                                        <td colspan='2'>DevOps and Cloud</td>
                                        </tr>

                                    </table>

                                    <base-button tag="a" href="#" type="primary" class="mt-4">
                                        Get Project Estimation
                                    </base-button>
                                </card>

                </div>

                  <div class="col-md-4 mb-4 mb-md-0">
                   
                       
                            <card class="border-0" hover shadow body-classes="py-5">
                            <icon name="ni ni-check-bold" type="primary" rounded class="mb-4">
                            </icon>
                            <h6 class="text-primary text-uppercase">Product Development</h6>

                            <p class="description mt-3">Improve your business with technology</p>

                            <table class='table'>

                            <tr>
                            <td colspan='2'>Business processes automation</td>
                            </tr>
                            <tr>
                            <td colspan='2'>IT consultation</td>
                            </tr>
                            <tr>
                            <td colspan='2'>Application Modernization</td>
                            </tr>
                            <tr>
                            <td colspan='2'>Cybersecurity services</td>
                            </tr>

                            </table>

                            <base-button tag="a" href="#" type="primary" class="mt-4">
                            Get Project Estimation
                            </base-button>
                            </card>

      


                  
                            
                    
                </div>

                <div class="col-md-4 mb-4 mb-md-0">
                   
                       

                        <card class="border-0" hover shadow body-classes="py-5">
                            <icon name="ni ni-check-bold" type="primary" rounded class="mb-4">
                            </icon>
                            <h6 class="text-primary text-uppercase">Idea validation</h6>

                            <p class="description mt-3">Safely test your product idea</p>

                            <table class='table'>

                            <tr>
                                <td colspan='2'>POC development to validate if your idea is feasible</td>
                            </tr>
                            <tr>
                               <td colspan='2'>Prototype development to visualize how your future product will function</td>
                            </tr>
                             <tr>
                               <td colspan='2'>MVP development to gain first users, measure and improve</td>
                            </tr>
                             <tr>
                               <td colspan='2'>Product scaling</td>
                            </tr>

                            </table>

                            <base-button tag="a" href="#" type="primary" class="mt-4">
                            Get Project Estimation
                            </base-button>
                            </card>

               
            
                </div>

            </div>
        </div>
        </section>
       

         <section class="section section-lg pt-0">
            <div class="container">
                <card gradient="warning"
                      no-body
                      shadow-size="lg"
                      class="border-0">
                    <div class="p-5">
                        <div class="row align-items-center">
                            <div class="col-lg-8">
                                <h3 class="text-white">Looking for something else?</h3>
                              
                            </div>
                            <div class="col-lg-3 ml-lg-auto">
                                <base-button tag="a" href="/#/contact-us"
                                             type="white" block size="lg">
                                    Contact Us
                                </base-button>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>

       
        
      
       
       

    </div>
</template>

<script>
export default {
  name: "home",
  components: {}
};
</script>
